<template>
    <component
        :is="contentItem.component"
        v-bind="contentItem.bind"
        v-on="contentItem.on">
        <template v-if="contentItem.child">
            <offer-item
                v-for="childItem in contentItem.child"
                :content-item="childItem"
                :key="childItem.key"/>
        </template>
    </component>
</template>

<script>
    export default {
        name: 'offer-item',
        props: {
            contentItem: {
                type: Object,
            },
        },
    };
</script>

<style scoped>

</style>
